export const OCR_LANGUAGES = [
  { code: 'eng', name: 'English' },
  { code: 'deu', name: 'German' },
  { code: 'fra', name: 'French' },
  { code: 'spa', name: 'Spanish' },
  { code: 'ita', name: 'Italian' },
  { code: 'por', name: 'Portuguese' },
  { code: 'nld', name: 'Dutch' },
  { code: 'dan', name: 'Danish' },
  { code: 'nor', name: 'Norwegian' },
  { code: 'swe', name: 'Swedish' },
  { code: 'fin', name: 'Finnish' },
  { code: 'pol', name: 'Polish' },
  { code: 'ces', name: 'Czech' },
  { code: 'slk', name: 'Slovak' },
  { code: 'hun', name: 'Hungarian' },
  { code: 'ron', name: 'Romanian' },
  { code: 'bul', name: 'Bulgarian' },
  { code: 'hrv', name: 'Croatian' },
  { code: 'srp', name: 'Serbian (Cyrillic)' },
  { code: 'srp_latn', name: 'Serbian (Latin)' },
  { code: 'bos', name: 'Bosnian' },
  { code: 'slv', name: 'Slovenian' },
  { code: 'mkd', name: 'Macedonian' },
  { code: 'sqi', name: 'Albanian' },
  { code: 'ell', name: 'Greek' },
  { code: 'tur', name: 'Turkish' },
  { code: 'rus', name: 'Russian' },
  { code: 'ukr', name: 'Ukrainian' },
  { code: 'bel', name: 'Belarusian' },
  { code: 'ara', name: 'Arabic' },
  { code: 'heb', name: 'Hebrew' },
  { code: 'fas', name: 'Persian' },
  { code: 'urd', name: 'Urdu' },
  { code: 'hin', name: 'Hindi' },
  { code: 'ben', name: 'Bengali' },
  { code: 'tam', name: 'Tamil' },
  { code: 'tel', name: 'Telugu' },
  { code: 'kan', name: 'Kannada' },
  { code: 'mal', name: 'Malayalam' },
  { code: 'mar', name: 'Marathi' },
  { code: 'guj', name: 'Gujarati' },
  { code: 'pan', name: 'Punjabi' },
  { code: 'nep', name: 'Nepali' },
  { code: 'chi_sim', name: 'Chinese (Simplified)' },
  { code: 'chi_tra', name: 'Chinese (Traditional)' },
  { code: 'jpn', name: 'Japanese' },
  { code: 'kor', name: 'Korean' },
  { code: 'tha', name: 'Thai' },
  { code: 'vie', name: 'Vietnamese' },
  { code: 'msa', name: 'Malay' },
  { code: 'ind', name: 'Indonesian' },
  { code: 'fil', name: 'Filipino' },
  { code: 'khm', name: 'Khmer' },
  { code: 'lao', name: 'Lao' },
  { code: 'mya', name: 'Myanmar' },
  { code: 'kat', name: 'Georgian' },
  { code: 'hye', name: 'Armenian' },
  { code: 'lat', name: 'Latin' },
  { code: 'epo', name: 'Esperanto' },
]

export const LANGUAGE_GROUPS = [
  {
    label: 'Western European',
    languages: ['eng', 'deu', 'fra', 'spa', 'ita', 'por', 'nld', 'dan', 'nor', 'swe', 'fin'],
  },
  {
    label: 'Central & Eastern European',
    languages: ['pol', 'ces', 'slk', 'hun', 'ron', 'bul', 'hrv', 'srp', 'srp_latn', 'bos', 'slv', 'mkd', 'sqi'],
  },
  {
    label: 'East Slavic & Greek/Turkish',
    languages: ['rus', 'ukr', 'bel', 'ell', 'tur'],
  },
  {
    label: 'Middle Eastern',
    languages: ['ara', 'heb', 'fas', 'urd'],
  },
  {
    label: 'South Asian',
    languages: ['hin', 'ben', 'tam', 'tel', 'kan', 'mal', 'mar', 'guj', 'pan', 'nep'],
  },
  {
    label: 'East & Southeast Asian',
    languages: ['chi_sim', 'chi_tra', 'jpn', 'kor', 'tha', 'vie', 'msa', 'ind', 'fil', 'khm', 'lao', 'mya'],
  },
  {
    label: 'Other',
    languages: ['kat', 'hye', 'lat', 'epo'],
  },
]

const langMap = Object.fromEntries(OCR_LANGUAGES.map(l => [l.code, l.name]))

export function getLanguageGroups() {
  return LANGUAGE_GROUPS.map(g => ({
    label: g.label,
    languages: g.languages.map(code => ({ code, name: langMap[code] || code })),
  }))
}

export function getLanguageName(code) {
  return langMap[code] || code
}
